import { EmptyContent, NullComponent } from '@ztechapps/webui.util'
import { RemarksActivity } from './RemarksActivity'
import type { TaskListComponents } from '@ztechapps/webui.contract'

export const components: TaskListComponents = {
  dataAction: {
    other: () => null,
  },
  emptyContent: EmptyContent,
  foot: () => null,
  remarksActivity: RemarksActivity,
  rowAction: NullComponent,
}
